// Phones and the Connect Android shell may keep a stale HTML shell → old JS. Compare the served bundle name and reload once.
const BUNDLE = /\/static\/js\/main\.[a-f0-9]+\.js/;
const KEY = "nx-build-reloaded";
let busy = false;

export async function checkFreshBuild() {
  const current = [...document.scripts].map((s) => s.src).find((s) => BUNDLE.test(s));
  if (!current || busy) return;
  busy = true;
  try {
    const r = await fetch(`/index.html?nx=${Date.now()}`, { cache: "no-store" });
    if (!r.ok) return;
    const m = (await r.text()).match(BUNDLE);
    if (m && !current.endsWith(m[0]) && sessionStorage.getItem(KEY) !== m[0]) {
      sessionStorage.setItem(KEY, m[0]);
      window.location.reload();
    }
  } catch (_) {
  } finally {
    busy = false;
  }
}

export function installFreshBuildCheck() {
  setTimeout(checkFreshBuild, 2500);
  document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") checkFreshBuild(); });
}
